export default {"src":"/_next/static/media/first-prize-trophy.4bef5117.svg","height":132,"width":103};